import { GTMAccountType } from "../types/swiftSavings";
import { buildAcqPayload, getOrCreateAttribId } from "./gtm";

export function pushFormStarted(
  accountType: GTMAccountType = "personal" /*'personal'|'corporate'*/
) {
  const accType = localStorage.getItem("altFinanceAccountType");
  const attribId = getOrCreateAttribId();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(
    Object.assign(
      {
        event: "form_started",
        event_id: attribId,
        flow: "online_account",
        account_type: accType || accountType,
      },
      buildAcqPayload()
    )
  );
  console.debug("DL push: form_started", { event_id: attribId });
}

export function pushBVNValidated(
  accountType: GTMAccountType = "personal" /*'personal'|'corporate'*/
) {
  const accType = localStorage.getItem("altFinanceAccountType");
  const attribId = getOrCreateAttribId();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(
    Object.assign(
      {
        event: "bvn_validated",
        event_id: attribId,
        flow: "online_account",
        account_type: accType || accountType,
      },
      buildAcqPayload()
    )
  );
  console.debug("DL push: bvn_validated", { event_id: attribId });
}

export function pushDocumentsUploaded(
  accountType: GTMAccountType = "personal"
) {
  const attribId = getOrCreateAttribId();
  const accType = localStorage.getItem("altFinanceAccountType");
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(
    Object.assign(
      {
        event: "signature_uploaded",
        event_id: attribId,
        flow: "online_account",
        account_type: accType || accountType,
      },
      buildAcqPayload()
    )
  );
  console.debug("DL push: signature_uploaded", { event_id: attribId });
}

export function pushAccountOpened(
  serverResponse: {
    account_type: GTMAccountType;
    account_value: string;
  } /*optional object from backend*/
) {
  const accType = localStorage.getItem("altFinanceAccountType");
  const attribId = getOrCreateAttribId();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(
    Object.assign(
      {
        event: "account_opened",
        event_id: attribId,
        flow: "online_account",
        account_type:
          accType ||
          (serverResponse && serverResponse.account_type) ||
          "personal",
        // account_value: (serverResponse && serverResponse.account_value) || 0,
      },
      buildAcqPayload()
    )
  );
  // optional: attempt to increase delivery chance before redirect
  try {
    const payload = JSON.stringify({
      event: "account_opened",
      event_id: attribId,
    });
    if (navigator.sendBeacon)
      navigator.sendBeacon("/_log/account_opened", payload);
  } catch (e) {}
  console.debug("DL push: account_opened", { event_id: attribId });
  // optional cleanup
  // try { localStorage.removeItem(LS.ATTR_ID); } catch(e){}
}
